import { Link, NavLink } from "react-router-dom"
import { Menu } from "lucide-react"
import { cn, imageBaseURL } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import CartButton from "@/components/shared/CartButton"

interface NavItem {
	label: string
	to: string
}

const DESKTOP_NAV: NavItem[] = [
	{ label: "Tratamientos", to: "/tratamientos" },
	{ label: "Productos", to: "/productos" },
	{ label: "Servicios", to: "/servicios" },
	{ label: "Nosotros", to: "/nosotros" },
	{ label: "Contacto", to: "/contacto" }
]

const MOBILE_NAV: NavItem[] = [
	...DESKTOP_NAV,
	{ label: "Términos", to: "/condiciones" },
	{ label: "Privacidad", to: "/privacidad" }
]

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
	cn("text-sm font-medium text-muted-foreground transition-colors hover:text-primary", isActive && "text-primary")

const mobileNavLinkClass = ({ isActive }: { isActive: boolean }) =>
	cn("block border-b px-4 py-4 text-base font-medium transition-colors hover:text-primary", isActive && "text-primary")

export default function NavBar(): React.JSX.Element {
	return (
		<header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur">
			<div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4">
				<Link to="/" className="flex shrink-0 items-center" aria-label="Biosany — inicio">
					<img src={imageBaseURL("biosany-logo.svg")} alt="Biosany" className="h-8 w-auto" width={225} height={80} />
				</Link>

				<div className="flex items-center gap-1 lg:gap-4">
					<nav className="hidden items-center gap-6 lg:flex">
						{DESKTOP_NAV.map(item => (
							<NavLink key={item.to} to={item.to} className={navLinkClass}>
								{item.label}
							</NavLink>
						))}
					</nav>

					<CartButton />

					<Sheet>
						<SheetTrigger asChild>
							<Button variant="ghost" size="icon" className="lg:hidden" aria-label="Abrir menú">
								<Menu className="h-6 w-6" />
							</Button>
						</SheetTrigger>
						<SheetContent side="right" className="flex w-full max-w-xs flex-col p-0">
							<SheetHeader className="border-b">
								<SheetTitle>Menú</SheetTitle>
							</SheetHeader>

							<nav className="flex flex-1 flex-col overflow-y-auto">
								{MOBILE_NAV.map(item => (
									<SheetClose asChild key={item.to}>
										<NavLink to={item.to} className={mobileNavLinkClass}>
											{item.label}
										</NavLink>
									</SheetClose>
								))}
							</nav>
						</SheetContent>
					</Sheet>
				</div>
			</div>
		</header>
	)
}
